import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PatientState {
  isReload: boolean;
  patientName: string | null;
  patientUserUuid: string | null;
  patientUuid: string | null;
  isPatientActive: boolean | null;
  isActionPanelExpanded: boolean;
  /**
   * Whether the chart's patient is the family's primary member (true) or a
   * dependent (false); null until the patient record has loaded.
   */
  isPatientPrimaryMember: boolean | null;
}

const initialState: PatientState = {
  isReload: false,
  patientName: null,
  patientUserUuid: null,
  patientUuid: null,
  isPatientActive: null,
  isActionPanelExpanded: false,
  isPatientPrimaryMember: null,
};

const patientChartingSlice = createSlice({
  name: "patientCharting",
  initialState,
  reducers: {
    setReload: (state, action: PayloadAction<boolean | null>) => {
      state.isReload = action.payload;
    },
    setPatientName: (state, action: PayloadAction<string | null>) => {
      state.patientName = action.payload;
    },
    setPatientUserUuid: (state, action: PayloadAction<string | null>) => {
      state.patientUserUuid = action.payload;
    },
    setPatientUuid: (state, action: PayloadAction<string | null>) => {
      state.patientUuid = action.payload;
    },
    setIsPatientActive: (state, action: PayloadAction<boolean | null>) => {
      state.isPatientActive = action.payload;
    },
    setIsActionPanelExpanded: (state, action: PayloadAction<boolean>) => {
      state.isActionPanelExpanded = action.payload;
    },
    setIsPatientPrimaryMember: (
      state,
      action: PayloadAction<boolean | null>,
    ) => {
      state.isPatientPrimaryMember = action.payload;
    },
  },
});

export const {
  setReload,
  setPatientName,
  setPatientUserUuid,
  setPatientUuid,
  setIsPatientActive,
  setIsActionPanelExpanded,
  setIsPatientPrimaryMember,
} = patientChartingSlice.actions;

export default patientChartingSlice.reducer;
